import { jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { Box } from "../../Box/Box.mjs";
import "../../Text/TextContext.mjs";
import "../../Heading/HeadingContext.mjs";
import "../../../css/lineHeightContainer.css.mjs";
import "../../../css/reset/reset.css.mjs";
import "../../../css/atoms/sprinkles.css.mjs";
import "../../../hooks/useIcon/icon.css.mjs";
import "../../../css/typography.css.mjs";
import { IconClose } from "../../icons/IconClose/IconClose.mjs";
import { FieldButtonIcon } from "../FieldButtonIcon/FieldButtonIcon.mjs";
const ClearField = ({ hide = false, onClear, label = "Clear", id, inputRef }) => {
  const clearHandler = useCallback(() => {
    if (typeof onClear !== "function") {
      return;
    }
    onClear();
    if (inputRef && typeof inputRef === "object" && inputRef.current) {
      inputRef.current.focus();
    }
  }, [onClear, inputRef]);
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: "span",
      height: "touchable",
      width: "touchable",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "fast",
      pointerEvents: hide ? "none" : void 0,
      opacity: hide ? 0 : void 0,
      children: /* @__PURE__ */ jsx(
        FieldButtonIcon,
        {
          id: `${id}-clear`,
          label,
          icon: /* @__PURE__ */ jsx(IconClose, {}),
          onMouseDown: clearHandler
        }
      )
    }
  );
};
export {
  ClearField
};
